import React, { Fragment } from 'react';
import { uniqueId } from 'lodash';
import ProductCard from '../ProductCard/ProductCard';
import useIsMobile from '../../Hooks/useIsMobile';

const ProductResults = ({ filteredProducts, selectedItem }) => {
  const isMobile = useIsMobile();
  const getFieldId = () => uniqueId();
  return (
    <ul
      className={`quick-search-result__products-wrapper quick-search-result__item-wrapper ${'product-list--search'}`}
    >
      {filteredProducts &&
        filteredProducts.map((item, index) => (
          <ProductCard
            key={`${item.name}-${index}`}
            {...item.productItemViewModel}
            fieldId={getFieldId()}
            type={'wide'}
          />
        ))}
    </ul>
  );
};

export default ProductResults;
